// @flow

import * as React from "react";
import cx from "classnames";
import GenericTile from "../GenericTile";

import styles from "./GridTile.scss";

type GridTileProps = {
  title: string,
  isActive: boolean
};

const GridTile = ({ title, isActive, ...restProps }: GridTileProps) => (
  <div className={styles.tileWrapper}>
    <GenericTile label={title} isActive={isActive} {...restProps} />
    {title && <div className={cx(styles.title, { [styles.titleActive]: isActive })}>{title}</div>}
  </div>
);

export default GridTile;
